import {Form} from "../helpers/forms/Form";
import {redirectClickToInput} from "../helpers/inputs/redirectEvents/redirectClickToInput";
import {setAsSelect2} from "../helpers/inputs";
import createElement from "../helpers/createElement";
import {getSingleInputByNameV3, getSingleInputElementByNameV3} from "../helpers/inputs/forms/fornInputHelpers";
import _ from "lodash";
import {ServerModalV3} from "../helpers/modals/ClassBased/ServerModalV3";
import {initSwiper} from "../helpers/swiper/swiper";
import {DesignStudioCustomChoiceModal} from "./DesignStudioCustomChoiceModal";


// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class DesignStudioChooseCategoryOptionForm extends Form {

	/** @var {DesignStudioChooseCategoryOptionFormDefs.Config} */
	config;

	constructor(config) {
		super(config);

		this.config = config;

		/** @var {HTMLElement} */
		this.categoryContainer = this.config.formElement;

		/** @var {DesignStudioChooseCategoryOptionFormDefs.ViewType} */
		this.viewType = this.categoryContainer.querySelector('input[name="view_type"]').value;

		/** @var {HTMLButtonElement} */
		this.customizeButton = this.categoryContainer.querySelector('.customize-button');

		this.customizeButton.addEventListener('click', () => {
			this.toggleViewMode();
			this.updateCategoryDom();
		})

		// Init choices
		/** @var {HTMLElement} */
		this.projectWideOptionsContainer = this.categoryContainer.querySelector('.project-wide-options-container');
		/** @var {HTMLElement} */
		this.customizableOptionsContainer = this.categoryContainer.querySelector('.customizable-options-container');

		// Init project wide options checkbox
		this.categoryContainer.querySelectorAll('.option').forEach(option => {
			const imageContainer = option.querySelector('.image-container');
			const checkboxContainer = option.querySelector('.option-checkbox-container');

			const checkbox = checkboxContainer.querySelector('input');

			redirectClickToInput(imageContainer, checkbox);
			checkboxContainer.addEventListener('click', () => {
				checkbox.dispatchEvent(new MouseEvent('click'));
			})

			const throttledClickHandler = _.debounce(
				() => {
					this.updateCategoryDom();
					this.notifyCustomerSelection();
				},
				16,
				{
					trailing: true,
					leading: false,
				}
			)

			checkbox.addEventListener('click', throttledClickHandler)
		});

		// Init customize options selects
		this.customizableOptionsContainer
			.querySelectorAll('select')
			.forEach(select => {
				setAsSelect2(select, {
					templateSelection: option => {
						return this.getSelect2SelectedCategoryHtml(option);
					},
					templateResult: option => {
						return this.getSelect2ResultHtml(option);
					},
					theme: 'bootstrap4 flex-grow-1 design-studio-choose-category-area-option-select',
				});

				$(select).on('change.select2', () => {
					if (select.value === 'custom-choice') {
						// A change event may be triggered may requested to update the UI and we do
						// not want to display the modal again
						if (select.dataset.doNotDisplayCustomModal) {
							// Clear flag
							select.dataset.doNotDisplayCustomModal = '';
							// End early
							return;
						}

						// Display custom choice modal
						this.displayCustomChoiceModalForPerAreaOptions(select)
					} else {
						this.notifyCustomerSelection();
					}
				})
			});


		// Setup info modal button
		this.projectWideOptionsContainer.querySelectorAll('.info-button').forEach(button => {
			button.addEventListener('click', (e) => {
				e.stopPropagation();
				this.displayOptionInfoModal(button.dataset.route)
			})
		})

		// Setup custom choice options
		//// We setup a helper function to make sure the modal is called only once
		const debouncedModalCall = _.debounce((optionInput) => {
			this.displayCustomChoiceModalForProjectWideOptions(optionInput);
		}, 1000, {trailing: false, leading: true})

		this.projectWideOptionsContainer.querySelectorAll('.option-checkbox-container input').forEach(optionInput => {
			optionInput.addEventListener('click', () => {
				if (optionInput.value === 'custom-choice') {
					debouncedModalCall(optionInput);
				}
			})
		})

		// Initial render
		this.updateCategoryDom();
	}

	toggleViewMode() {
		if (this.viewType === 'per-area') {
			this.viewType = 'project-wide';
		} else {
			this.viewType = 'per-area';
		}

		this.notifyCustomerSelection();
	}

	updateCategoryDom() {
		if (this.viewType === 'project-wide') {
			// Display proper container
			this.customizableOptionsContainer.classList.add('d-none');
			this.projectWideOptionsContainer.classList.remove('d-none');

			// Set button label
			this.customizeButton.innerText = 'Customize Rooms';

			// Clear project wide options classes
			this.categoryContainer.querySelectorAll('.option')
				.forEach(option => {
					option.classList.remove('selected');
				})

			// Mark selected option
			const selectedOption = this.projectWideOptionsContainer.querySelector('input:checked')

			if (selectedOption) {
				// Mark parent option element as selected
				selectedOption.closest('.option').classList.add('selected');
			}

			// Setup custom choice if it exists
			/** @var {HTMLInputElement} */
			const customChoiceInput = this.categoryContainer.querySelector('input[value="custom-choice"]');

			if (customChoiceInput) {
				const relatedImageContainer = customChoiceInput.closest('.option').querySelector('.image-container');

				// Clear custom choice to default text
				relatedImageContainer.innerHTML = '<div class="no-image-fallback text-center">Custom Choice <br><small>UPLOAD YOUR OWN PICTURES</small></div>'

				// If selected, set picture as first uploaded picture as preview
				if (customChoiceInput.checked && (customChoiceInput.dataset.customChoice || customChoiceInput.dataset.ideas_board_post_id)) {
					try {
						/** @var {DesignStudioCustomChoiceModalDefs.CustomChoice} */
						const customChoice = JSON.parse(customChoiceInput.dataset.customChoice);

						if (customChoice.pictures.length) {
							// Get first image
							const firstPicturePath = customChoice.pictures[0].download_url;

							// Update image container
							relatedImageContainer.innerHTML = `<img src="${firstPicturePath}">`;
						} else if (customChoice.related_idea_board_post) {
							relatedImageContainer.innerHTML = `<img src="${customChoice.related_idea_board_post.public_image_path}">`;
						}
					} catch (e) {
						console.log(e)
					}
				}
			}

		} else {
			// Per area display mode
			// Display proper container
			this.projectWideOptionsContainer.classList.add('d-none');
			this.customizableOptionsContainer.classList.remove('d-none');

			// Set button label
			this.customizeButton.innerText = 'Project Wide';
		}
	}

	/**
	 * @param selectedOption
	 */
	getSelect2SelectedCategoryHtml(selectedOption) {
		const name = selectedOption.element.dataset.name;
		let image = selectedOption.element.dataset.image;

		if (selectedOption.id === 'custom-choice') {
			// If possible retrieve existing custom choice from select element
			/** @var {HTMLSelectElement} */
			const select = selectedOption.element.parentElement;
			/** @var {DesignStudioCustomChoiceModalDefs.CustomChoice} */
			let existingCustomChoice = undefined;

			try {
				if (select.dataset.customChoice) {
					existingCustomChoice = JSON.parse(select.dataset.customChoice);
				}
			} catch (e) {
				console.error('Error retrieving custom choice')
				console.error(e)
			}

			if (existingCustomChoice) {
				if (existingCustomChoice.pictures[0]) {
					image = existingCustomChoice.pictures[0].download_url;
				} else if (existingCustomChoice.related_idea_board_post) {
					image = existingCustomChoice.related_idea_board_post.public_image_path;
				}
			}
		}

		const element = createElement(`
			<div class="h-100 d-flex">
				<div
					class="name"
					style="padding-top: 60px; padding-left: 20px; flex-grow: 1"
				>
					${name}
				</div>
				<div class="image-container border-left" style="width: 80px">
					${image ? `
								<img src="${image}">
							` : `
								<div class="no-image-fallback text-center p-2" style="font-size: 0.7rem; white-space: normal">
									${name}
								</div>
							`}
				</div>
			</div>
		`);

		return $(element);
	}

	getSelect2ResultHtml(option) {
		if (!option.id) {
			return option.text;
		}

		const name = option.element.dataset.name;
		const image = option.element.dataset.image;
		const element = createElement(`
			<div class="design-studio-choose-category-area-option-select2-result, h-100 d-flex">
				<div
					class="name w-75 pl-4 d-flex align-items-center"
				>
					${name}
				</div>
				<div class="image-container w-25" style="height: 60px">
					${image ? `
								<img src="${image}">
							` : `
								<div class="no-image-fallback text-center">
									${name}
								</div>
							`}

				</div>
			</div>
		`);

		return $(element);
	}

	notifyCustomerSelection() {
		if (this.config.onSelection) {
			this.config.onSelection(this.getCustomerSelection())
		}
	}

	/**
	 * @return {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection}
	 */
	getCustomerSelection() {
		/** @var {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} */
		const result = {
			category_id: this.getCategoryId(),
			per_area_options: [],
		}

		if (this.viewType === 'project-wide') {
			const selectedRadio = getSingleInputElementByNameV3(
				this.config.formElement.querySelector('.project-wide-options-container'),
				this.getCategoryId(), // The category id was used as the radio button name
			)

			if (selectedRadio) {
				if (selectedRadio.value === 'custom-choice') {
					// Retrieve custom choice from input
					if (selectedRadio.dataset.customChoice) {
						result.option = JSON.parse(selectedRadio.dataset.customChoice);
					}
				} else {
					result.option = {
						option_id: selectedRadio.value,
						name: selectedRadio.dataset.optionName,
					}
				}

			} else {
				result.option = {
					option_id: null,
					name: null,
				}
			}

		} else {
			const perAreaContainer = this.config.formElement.querySelector('.customizable-options-container');

			perAreaContainer.querySelectorAll('select').forEach(select => {
				const areaId = select.name;
				const optionId = select.value;

				if (select.value === 'custom-choice') {
					// Retrieve custom choice
					const customChoice = JSON.parse(select.dataset.customChoice);

					result.per_area_options.push({
						option: customChoice,
						area_id: areaId,
					})
				} else {
					result.per_area_options.push({
						option: {
							name: '', // Not relevant here
							option_id: optionId,
						},
						area_id: areaId,
					})
				}
			})
		}

		return result;
	}

	clearCustomerSelection() {
		// Clear project wide selections
		this.config.formElement
			.querySelectorAll('.project-wide-options-container input')
			.forEach(input => {
				input.checked = false;
			})

		// Refresh dom
		this.updateCategoryDom();

		// Notify parents
		this.notifyCustomerSelection();
	}

	getCategoryId() {
		return getSingleInputByNameV3(this.config.formElement, 'category_id');
	}

	displayOptionInfoModal(modalRoute) {
		new ServerModalV3(modalRoute, {
			init(modal) {
				const modalContainer = modal.modalContainer;
				// Init swiper
				initSwiper(
					modalContainer.querySelector('.swiper'),
					{},
					modal
				);
			}
		})
	}

	/**
	 * @param {HTMLInputElement} input
	 */
	displayCustomChoiceModalForProjectWideOptions(input) {
		// Retrieve custom choice
		let existingCustomChoice = undefined;
		try {
			if (input.dataset.customChoice) {
				existingCustomChoice = JSON.parse(input.dataset.customChoice);
			}
		} catch (e) {
			console.error('Error retrieving custom choice')
			console.error(e)
		}

		// Create modal copy
		const modalContainer = document.querySelector('.design-studio-custom-choice-modal.template');
		/** @var {HTMLElement} */
		const modalContainerCopy = modalContainer.cloneNode(true);

		// Remove .template class name
		modalContainerCopy.classList.remove('template');

		// Append to dom
		modalContainer.parentElement.appendChild(modalContainerCopy)

		const customChoiceModal = new DesignStudioCustomChoiceModal({
			modalContainer: modalContainerCopy,
			onSuccess: () => {
				// Save response as data field on input for later use
				input.dataset.customChoice = JSON.stringify(customChoiceModal.getData());

				this.updateCategoryDom();
				this.notifyCustomerSelection();

				// Remove modal DOM element
				modalContainerCopy.remove()
			},
			onBackRequest: () => {
				// Only clear selection if no customChoice exists in the input.
				// This prevents us from deleting any existing selection and because onSuccess is called
				// before hiding the modal it won't clear the selection when the modal is confirmed
				if (!input.dataset.customChoice) {
					// Remove selection
					input.checked = false;
					// Re render
					this.updateCategoryDom();
					this.notifyCustomerSelection();
				}

				// Remove modal DOM element
				modalContainerCopy.remove()
			},
			existingCustomChoice,
		});

		customChoiceModal.display();
	}

	/**
	 * @param {HTMLSelectElement} areaSelect
	 */
	displayCustomChoiceModalForPerAreaOptions(areaSelect) {
		// Retrieve custom choice
		let existingCustomChoice = undefined;
		try {
			if (areaSelect.dataset.customChoice) {
				existingCustomChoice = JSON.parse(areaSelect.dataset.customChoice);
			}
		} catch (e) {
			console.error('Error retrieving custom choice')
			console.error(e)
		}

		// Create modal copy
		const modalContainer = document.querySelector('.design-studio-custom-choice-modal.template');
		/** @var {HTMLElement} */
		const modalContainerCopy = modalContainer.cloneNode(true);

		// Remove .template class name
		modalContainerCopy.classList.remove('template');

		// Append to dom
		modalContainer.parentElement.appendChild(modalContainerCopy)

		const customChoiceModal = new DesignStudioCustomChoiceModal({
			modalContainer: modalContainerCopy,
			onSuccess: () => {
				// Save response as data field on input for later use
				areaSelect.dataset.customChoice = JSON.stringify(customChoiceModal.getData());

				this.updateCategoryDom();
				this.notifyCustomerSelection();

				// Notify select 2 of a change, so it re renders any image the user uploaded
				// while setting a flag to skip opening the modal again
				areaSelect.dataset.doNotDisplayCustomModal = 'true';
				$(areaSelect).trigger('change.select2');

				// Remove modal DOM element
				modalContainerCopy.remove()
			},
			onBackRequest: () => {
				// Only clear selection if no customChoice exists in the input.
				// This prevents us from deleting any existing selection and because onSuccess is called
				// before hiding the modal it won't clear the selection when the modal is confirmed
				if (!areaSelect.dataset.customChoice) {
					// Remove selection
					areaSelect.selectedIndex = 0;
					// Notify select 2 of manual change
					$(areaSelect).trigger('change.select2');

					// Re render
					this.updateCategoryDom();
					this.notifyCustomerSelection();
				}

				// Remove modal DOM element
				modalContainerCopy.remove()
			},
			existingCustomChoice,
		});

		customChoiceModal.display();
	}
}

export {DesignStudioChooseCategoryOptionForm}
